import { Injectable } from '@angular/core';
import { VariavelFormula } from '../models/variavel-formula';
import { HttpClient } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class VariavelFormulaService {

  constructor(
    private http: HttpClient
  ) { }

  salvar(variavelFormula: VariavelFormula) {
    return this.http.post(globals.apiUrl + '/api/VariavelFormula/Salvar', variavelFormula);
  }

  consultarLista() {
    return this.http.get<VariavelFormula[]>(globals.apiUrl + '/api/VariavelFormula/Lista');
  }
}
